module.exports = __webpack_public_path__ + "img/loading.dce59927.gif";